import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isTokenValid } from '../api';
import { loginUrl } from '../lib/redirect';

export default function PrivateRoute({ children }) {
  const { auth } = useAuth();
  const location = useLocation();
  if (!auth || auth.role !== 'admin') {
    return <Navigate to={loginUrl(location)} replace />;
  }
  // A stored-but-expired token would otherwise render the admin shell while
  // every API call fails with 401 — which a page refresh cannot recover from.
  // Send the user to login with a flag so they see why they were signed out.
  if (!isTokenValid(auth.token)) {
    return <Navigate to={loginUrl(location, 'expired=1')} replace />;
  }
  return children;
}
